var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":_vm.id,"title":_vm._f("i18n")('QR code'),"button-size":"sm","centered":"","hide-footer":"","content-class":"rounded-8"},on:{"show":_vm.showModal,"hidden":_vm.resetModal}},[(_vm.token)?_c('div',{staticClass:"qr-box"},[_c('QRCanvas',{attrs:{"options":_vm.options}})],1):_c('div',[_c('Loader')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }